module.exports = pdfmake/build/vfs_fonts;


//////////////////
// WEBPACK FOOTER
// external "pdfmake/build/vfs_fonts"
// module id = 2397
// module chunks = 0